import { PsDocumentStats } from './PsDocumentStats';
import { PsDocumentSchema } from "./PsDocumentSchema";

export class PsCompany {

    _id; // number
    _nif; // string
    _ccc; // string
    _name; // string
    _phone; // string
    _email; // string
    _stats; // PsDocumentStats
    _active; // boolean
    _address; // string
    _imported; // boolean # Si es una empresa importada (todavía no está en nuestro sistema)
    _contactPerson; // string
    _documentSchema; // PsDocumentSchema
    _documentSchemaMonthly; // PsDocumentSchema

    constructor(
        id,
        nif,
        ccc,
        name,
        phone,
        email,
        stats,
        active,
        address,
        imported,
        contactPerson,
        documentSchema,
        documentSchemaMonthly,
    ) {
        this._id = id;
        this._nif = nif;
        this._ccc = ccc;
        this._name = name;
        this._phone = phone;
        this._email = email;
        this._stats = stats;
        this._active = active;
        this._address = address;
        this._imported = imported;
        this._contactPerson = contactPerson;
        this._documentSchema = documentSchema;
        this._documentSchemaMonthly = documentSchemaMonthly;
    }

    static fromAPICompanies(companies) {
        return companies.map((company) => PsCompany.fromAPICompany(company));
    }

    static fromAPICompany(company) {
        const stats = company.document_stats
            ? PsDocumentStats.fromAPIDocumentStats(company.document_stats)
            : PsDocumentStats.null();

        const documentSchema = company.document_schema
            ? PsDocumentSchema.fromAPIDocumentSchema(company.document_schema)
            : PsDocumentSchema.null();

        const documentSchemaMonthly = company.document_schema_monthly
            ? PsDocumentSchema.fromAPIDocumentSchema(company.document_schema_monthly)
            : PsDocumentSchema.null();

        return new this(
            company.id,
            company.nif || '',
            company.ccc || '',
            company.name || '',
            company.phone || '',
            company.email || '',
            stats,
            !company.disabled,
            company.address || '',
            false,
            company.contact_person || '',
            documentSchema,
            documentSchemaMonthly,
        );
    }

    static fromAPIImportation(company) {
        return new this(
            company.code,
            company.cif,
            '',
            company.name,
            '',
            '',
            PsDocumentStats.null(),
            true,
            '',
            true,
            '',
            PsDocumentSchema.null(),
            PsDocumentSchema.null(),
        );
    }

    id() {
        return this._id;
    }

    nif() {
        return this._nif;
    }

    ccc() {
        return this._ccc;
    }

    name() {
        return this._name;
    }

    phone() {
        return this._phone;
    }

    email() {
        return this._email;
    }

    isActive() {
        return this._active;
    }

    address() {
        return this._address;
    }

    contactPerson() {
        return this._contactPerson;
    }

    isImported() {
        return this._imported;
    }

    stats() {
        return this._stats;
    }

    documentSchema() {
        return this._documentSchema;
    }

    documentSchemaMonthly() {
        return this._documentSchemaMonthly;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/company/PsCompany.js